import * as Types from 'src/actions/project/cap-table/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import CapTable from 'src/value-objects/CapTable';

export interface GetProjectCapTableAttempt extends Action {
  type: Types.GET_PROJECT_CAP_TABLE_ATTEMPT;
}

export interface GetProjectCapTableSuccess extends Action {
  type: Types.GET_PROJECT_CAP_TABLE_SUCCESS;
  payload: CapTable;
}

export interface GetProjectCapTableFailure extends Action {
  type: Types.GET_PROJECT_CAP_TABLE_FAILURE;
}

export type GetProjectCapTableAction =
  GetProjectCapTableAttempt
  | GetProjectCapTableSuccess
  | GetProjectCapTableFailure;

export interface GetProjectCapTableThunk extends ThunkAction<Promise<GetProjectCapTableAction>, RootState, string> {
}

export const getProjectCapTableAttempt: ActionCreator<GetProjectCapTableAttempt> = () => (
  {
    type: Types.GET_PROJECT_CAP_TABLE_ATTEMPT
  }
);

export const getProjectCapTableSuccess: ActionCreator<GetProjectCapTableSuccess> = (
  projectCapTable: CapTable) => (
  {
    type: Types.GET_PROJECT_CAP_TABLE_SUCCESS,
    payload: projectCapTable
  }
);

export const getProjectCapTableFailure: ActionCreator<GetProjectCapTableFailure> = () => (
  {
    type: Types.GET_PROJECT_CAP_TABLE_FAILURE
  }
);

export const getProjectCapTable: ActionCreator<GetProjectCapTableThunk> =
  (id: string): GetProjectCapTableThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetProjectCapTableAction> => {
      dispatch(getProjectCapTableAttempt());

      return ApiClient.projectCapTable.get(id)
        .then((response: AxiosResponse<CapTable>): GetProjectCapTableSuccess => {
          const projectCapTable: CapTable = response.data;
          return dispatch(getProjectCapTableSuccess(projectCapTable));
        }).catch((): GetProjectCapTableFailure => {
          return dispatch(getProjectCapTableFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/cap-table/GetProjectCapTable.actions.tsx